// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"732":"e4896fa6","977":"7dc088b4"}[chunkId] + ".chunk.js";
};